import { render } from "./LuggageDetails.vue?vue&type=template&id=13bd281a&scoped=true"
import script from "./LuggageDetails.vue?vue&type=script&lang=js"
export * from "./LuggageDetails.vue?vue&type=script&lang=js"

import "./LuggageDetails.vue?vue&type=style&index=0&id=13bd281a&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bd281a"]])

export default __exports__